import {useEffect, useId, useRef} from "react";

interface Props {
    value: boolean,
    onUpdateFunc: (value: boolean) => void,
    label?: string,
    ariaLabel?: string,
    className?: string,
    disabled?: boolean,
    indeterminate?: boolean,
}

export default function Checkbox({value, onUpdateFunc, label, ariaLabel, className = "font-medium text-gray-900", disabled = false, indeterminate = false}: Props) {

    const id = useId()
    const inputRef = useRef<HTMLInputElement>(null)

    useEffect(() => {
        if (inputRef.current) inputRef.current.indeterminate = indeterminate
    }, [indeterminate])

    return (
        <div className={`inline-flex items-center gap-x-2 ${disabled ? 'opacity-50' : ''}`}>
            <div className="flex h-6 shrink-0 items-center">
                <div className="group grid size-4 grid-cols-1">
                    <input
                        ref={inputRef}
                        id={id + 'checkbox'}
                        name="checkbox"
                        type="checkbox"
                        checked={value}
                        disabled={disabled}
                        aria-label={ariaLabel}
                        onChange={(e) => onUpdateFunc(e.target.checked)}
                        className="col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white checked:liteprimary checked:bg-primary indeterminate:border-primary indeterminate:bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                    />
                    <svg
                        fill="none"
                        viewBox="0 0 14 14"
                        className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-gray-950/25"
                    >
                        <path
                            d="M3 8L6 11L11 3.5"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="opacity-0 group-has-[:checked]:opacity-100"
                        />
                        <path
                            d="M3 7H11"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="opacity-0 group-has-[:indeterminate]:opacity-100"
                        />
                    </svg>
                </div>
            </div>
            {label && (
                <label htmlFor={id + 'checkbox'} className={className}>
                    {label}
                </label>
            )}
        </div>

    )
}
